import React from 'react';
import { Zap } from 'lucide-react';
import { Badge } from './ui/Badge';

interface CreditsChipProps {
  balance: number | null | undefined;
  included: number | null | undefined;
  status?: string | null;
}

function formatCredits(n: number): string {
  return Math.round(n).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

const CreditsChip: React.FC<CreditsChipProps> = ({ balance, status }) => {
  if (balance == null) return null;

  const variant = balance <= 0 ? 'danger' : 'default';

  const tooltip = `Credits remaining: ${formatCredits(balance)}${status ? ` · ${status}` : ''}`;

  return (
    <span
      data-tooltip={tooltip}
      data-tooltip-placement="right"
      className="inline-flex"
    >
      <Badge variant={variant} small className="flex items-center gap-0.5 cursor-default">
        <Zap className="w-2.5 h-2.5 flex-shrink-0" />
        {formatCredits(balance)} cr
      </Badge>
    </span>
  );
};

export default CreditsChip;
